import { render, staticRenderFns } from "./DwGoods.vue?vue&type=template&id=4896cb68&scoped=true"
import script from "./DwGoods.vue?vue&type=script&lang=js"
export * from "./DwGoods.vue?vue&type=script&lang=js"
import style0 from "./DwGoods.vue?vue&type=style&index=0&id=4896cb68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4896cb68",
  null
  
)

export default component.exports